































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SuporteUsuariosRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteUsuariosRemuneracaoStore';
@Component

export default class RemuneracaoSuporteAdminUsuariosRightNavBar extends Vue {
  get getSuporteUsuariosRemuneracaoStore() {
    return getModule(SuporteUsuariosRemuneracaoStore, this.$store)
  }

  get drawer() {
    return this.getSuporteUsuariosRemuneracaoStore.drawer
  }

  set drawer(value: boolean) {
    this.getSuporteUsuariosRemuneracaoStore.setDrawer(value)
  }

  get filtroNome() {
    return this.getSuporteUsuariosRemuneracaoStore.filtroNome
  }

  set filtroNome(value: string) {
    this.getSuporteUsuariosRemuneracaoStore.setFiltroNome(value)
  }

  get filtroCpf() {
    return this.getSuporteUsuariosRemuneracaoStore.filtroCpf
  }

  set filtroCpf(value: string) {
    this.getSuporteUsuariosRemuneracaoStore.setFiltroCpf(value)
  }

  get filtroEmail() {
    return this.getSuporteUsuariosRemuneracaoStore.filtroEmail
  }

  set filtroEmail(value: string) {
    this.getSuporteUsuariosRemuneracaoStore.setFiltroEmail(value)
  }

  get pagination() {
    return this.getSuporteUsuariosRemuneracaoStore.pagination
  }

  async search() {
    this.getSuporteUsuariosRemuneracaoStore.setPage(1)
    this.getSuporteUsuariosRemuneracaoStore.setFilterLoading(true)
    await this.getSuporteUsuariosRemuneracaoStore.getUsuarios()
    this.getSuporteUsuariosRemuneracaoStore.setFilterLoading(false)
  }

  async clear() {
    this.getSuporteUsuariosRemuneracaoStore.setFilterLoading(true)
    this.getSuporteUsuariosRemuneracaoStore.clearFilters()
    await this.getSuporteUsuariosRemuneracaoStore.getUsuarios()
    this.getSuporteUsuariosRemuneracaoStore.setFilterLoading(false)
  }
}
